import script from "./ProgressBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgressBar.vue?vue&type=script&setup=true&lang=js"

import "./ProgressBar.vue?vue&type=style&index=0&id=d7605172&scoped=true&lang=css"

import exportComponent from "/home/forge/princes-trust.ac.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7605172"]])

export default __exports__